import { Injectable, inject } from '@angular/core';
import { collection, CollectionReference } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FIRESTORE } from '@core/firebase/firebase.tokens';
import { collectionData$ } from '@core/firebase/firebase-rxjs.utils';
import { PdiAccount } from '@customer/models/pdi-account.model';

@Injectable({
  providedIn: 'root',
})
export class PdiAccountsService {
  private readonly firestore = inject(FIRESTORE);
  private readonly collectionRef: CollectionReference;

  constructor() {
    this.collectionRef = collection(this.firestore, 'pdiAccounts');
  }

  streamAllAccounts(): Observable<PdiAccount[]> {
    return collectionData$(this.collectionRef, { idField: 'id' }).pipe(
      map(data => data as unknown as PdiAccount[])
    );
  }
}
